import React from "react";
import blogData from "../components/sub/socialPosts.json";
import classes from "../pages/Post.module.css";
import WBWalletFreezing from "../images/socialMedia/WBWalletFreezing.png";
import Expensesonrepeat from "../images/socialMedia/WB202505-Expensesonrepeat.png";
import WB202503 from "../images/socialMedia/WB202503-002.png";
import SnowSun from "../images/socialMedia/WB-Wallet-Snow-Sun.png";
import SocialPost from "./SocialPost";
import WorldEmoji from "../images/socialMedia/World Emoji Day-17 July.png";
import SlowTrack from "../images/socialMedia/WB2025-Slow Track.png";
import WomansDay from "../images/socialMedia/WB-Womens Day-Final.png";
import LuckyDraw from "../images/socialMedia/Lucky Draw T-Shirts-Are You Next.png";
import StuckinQue from "../images/socialMedia/WB-Stuck in the Que.png";
import SolutionWebridge from "../images/socialMedia/WB2025-Solution with and without WeBridge.png";

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}
export default function SocialMediaPosts() {
  const posts = [
    { id: 1, title: "Wallet Freezing", image: WBWalletFreezing },
    { id: 2, title: "Expenses on Repeat", image: Expensesonrepeat },
    { id: 3, title: "WB202503", image: WB202503 },
    { id: 4, title: "Yet Another Post", image: SnowSun },
    { id: 5, title: "WorldEmoji", image: WorldEmoji },
    { id: 6, title: "SlowTrack", image: SlowTrack },
    { id: 7, title: "WomansDay", image: WomansDay },
    { id: 8, title: "LuckyDraw", image: LuckyDraw },
    { id: 9, title: "StuckinQue", image: StuckinQue },
    { id: 10, title: "SolutionWebridge", image: SolutionWebridge },
  ];
  const slides = chunkArray(posts, 2);
  return (
    <>
      <div id="demo" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {slides.map((group, idx) => (
            <div
              key={idx}
              className={`carousel-item${idx === 0 ? " active" : ""}`}
            >
              <div className="d-flex justify-content-center align-items-center">
                {group.map((post) => (
                  <SocialPost
                    key={post.id}
                    imgeUrl={post.image}
                    title={post.title}
                    alt={post.title}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          style={{ color: "black" }}
          type="button"
          data-bs-target="#demo"
          data-bs-slide="prev"
        >
          <span className="carousel-control-next-icon">
            <i className="bi bi-chevron-left" style={{ color: "black" }}></i>
          </span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#demo"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon">
            <i className="bi bi-chevron-right" style={{ color: "black" }}></i>
          </span>
        </button>
      </div>
    </>
  );
}
